exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Dessert-module__dessert___2wanN{display:flex;justify-content:center;align-items:center;height:var(--app-height);width:100vw;background-color:#e8d9d4;position:relative;overflow:hidden}.Dessert-module__dessert___2wanN .Dessert-module__top-left___1778T{position:absolute;left:30px;top:30px;z-index:0}.Dessert-module__dessert___2wanN .Dessert-module__bottom-right___3UW-F{position:absolute;right:60px;bottom:80px;z-index:0}.Dessert-module__dessert___2wanN .Dessert-module__tumbleweed___KjMBO{position:absolute;left:100px;bottom:100px;z-index:0}.Dessert-module__dessert___2wanN .Dessert-module__tumbleweed___KjMBO img{height:200px;width:auto}@media screen and (max-width:1200px){.Dessert-module__dessert___2wanN .Dessert-module__top-left___1778T{display:none}}", ""]);

// exports
exports.locals = {
	"dessert": "Dessert-module__dessert___2wanN",
	"top-left": "Dessert-module__top-left___1778T",
	"bottom-right": "Dessert-module__bottom-right___3UW-F",
	"tumbleweed": "Dessert-module__tumbleweed___KjMBO"
};